import { CommonModule, LocationStrategy } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalController, NavController } from "@ionic/angular/standalone";
import { IonButton } from "@ionic/angular/standalone";
import { TranslateModule } from "@ngx-translate/core";
import { timer } from "rxjs";

@Component({
  selector: "app-gift-member-success",
  templateUrl: "./gift-member-success.component.html",
  styleUrls: ["./gift-member-success.component.scss"],
  imports: [
    IonButton,
    CommonModule,
    FormsModule, 
    TranslateModule, 
  ],
})
export class GiftMemberSuccessComponent implements OnInit {
  @Input() giftedMemberDetails: any;
  @Input("transaction") transaction: any;
  @Input("paymentSuccessDetails") paymentSuccessDetails: any;

  constructor(
    private modalController: ModalController,
    private navCtrl: NavController,
    private locationStrategy: LocationStrategy
  ) {}

  ngOnInit() {}

  // Go To Tabs Home Functionality
  goToTabsFunc() {
    this.modalController.dismiss();
    //refactoring settimeout remove and used timer of rxjs 
    timer(300).subscribe(() => {
      history.pushState(null, "", window.location.href);

      this.locationStrategy.onPopState(() => {
        history.pushState(null, "", window.location.href);
      });
    });
    this.navCtrl.navigateForward("/tabs/home");
  }

  public navigateToWallet() {
    this.modalController.dismiss("navigateToWallet");
  }

  public navigateToHome() {
    this.modalController.dismiss("navigateToHome");
  }
}
